import { Location } from '@angular/common';
import { Component, ViewChild, ElementRef, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../helpers/common.service';
@Component({
	standalone: false,
	selector: 'app-analytics',
	templateUrl: './analytics.component.html',
	styleUrls: ['./analytics.component.scss'],
})
export class AnalyticsComponent {
	@ViewChild('iframe') iframe!: ElementRef;
	@Input() displayAnalyticsSection: boolean = false;
	isApkWebView = false;
	holdingData:any[] = []
	payloadData: any;
	clientId: any;
	isPartner: any;
	constructor(private route: ActivatedRoute, private cookieService: CookieService, private commonService: CommonService, private location: Location) {
		// if(this.displayAnalyticsSection){
			this.route.queryParams.subscribe((params: any) => {
				this.isApkWebView =  JSON.parse(params?.['isApkWebView']);
				this.clientId =	params?.['code'];
				this.isApkWebView = JSON.parse(params?.['isApkWebView'])
			});
			this.holdingData = this.commonService.get('totalHoldings') ? JSON.parse(this.commonService.get('totalHoldings') || "{}") : "[]";
		// }
	}

	ngOnInit() {
		addEventListener("beforeunload", (event) => { 
			this.cookieService.set('isresfreshed','1');
		})
		this.commonService.set('saveClientId', 'true');
	}

	loadIframe(){
		if(this.holdingData.length > 0){
			// setTimeout(() => {
			if(JSON.parse(this.commonService.get('equityTabValue') || "{}") == 'True'){
				this.payloadData = JSON.stringify({
					source: "IIFL",
					data: {
						holdings: this.holdingData,
						imported_holdings: true
					},
				});
			}
			else{
				this.payloadData = JSON.stringify({
					source: "IIFL",
					data: {
						holdings: this.holdingData
					},
				});
			}
				
				this.iframe.nativeElement.contentWindow.postMessage(this.payloadData, "*");
	
				// this.iframe.nativeElement.setAttribute('src', "https://newsiifl.trendlyne.com/clientapi/irwin/webview/FHZVJwFXDC/portfolio-report/");
			// }, 1000);
		}
	}
	goBack(){
		this.commonService.set('fromConnected','true')
    	this.location.back();
	}

}

